import React, { useState, useEffect } from 'react';
import Select from "react-select";
import SelectSearch, { fuzzySearch } from "react-select-search";
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import DatePicker from 'react-date-picker';
import 'bootstrap/dist/js/bootstrap.min.js';

import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import PropTypes from 'prop-types';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import '../style/custom.css';
import configData from '../configData.json';
import SweetAlert from "react-bootstrap-sweetalert";
import { Spinner } from 'react-bootstrap';

import ImplementationModal from '../components/ImplementationModal';
import { toLocalDate } from '../components/Utlities';
import { format } from 'date-fns';

export default function ImplementationSetup(props) {

    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [contractManagementDetailData, setContractManagementDetailData] = useState([]);
    const [fbauditPaymentDetailData, setFbauditPaymentDetailData] = useState([]);
    const [supplyChainDetailData, setSupplyChainDetailData] = useState([]);
    const [upsellDetailData, setUpsellDetailData] = useState([]);
    const [businessLostDetailData, setBusiessLostDetailData] = useState([]);
    const [businessReviewDetailData, setBusinessReviewDetailData] = useState([]);
    const [contractAmendmentDetailData, setContractAmendmentDetailData] = useState([]);
    const [billableItemsDetailData, setBillableItemsDetailData] = useState([]);

    const [customerLoading, isCustomerLoading] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedCustomerName, setSelectedCustomerName] = useState('');
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [owners, setOwners] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [lastCloseDate, setLastCloseDate] = useState('');

    const [showAlert, setShowAlert] = useState(true);

    const [StatusBills, setStatusBills] = useState([]);

    const [hidden, setHidden] = useState(true);
    const [hiddenError, setHiddenError] = useState(true);

    const [locationTypeOptions, setLocationTypeOptions] = useState([]);
    const [locationNameOptions, setLocationNameOptions] = useState([]);
    const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
    const [fundingTypeOptions, setFundingTypeOptions] = useState([]);
    const [contractCompletedOptions, setContractCompletedOptions] = useState([]);
    const [serviceRegionOptions, setServiceRegionOptions] = useState([]);
    const [modalData, setModalData] = useState(null);





    const LoadLocationType = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationType`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let locationTypeOptions = [];

            data.forEach((locationType) => {
                const loctype = {
                    "name": locationType.codeDesc,
                    "value": locationType.codeID
                };
                locationTypeOptions.push(loctype);
            });

            const defaultLocType = {
                "name": "-- Select A Value --",
                "value": 0
            };

            locationTypeOptions.unshift(defaultLocType);
            setLocationTypeOptions(locationTypeOptions);
        } catch (error) {
            console.error('Error loading location types:', error);
        } finally {
        }

    };

    const LoadLocationName = async (custKey, locType) => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationName/${custKey}/${locType}`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let locationNameOptions = [];

            data.forEach((locationName) => {
                const locName = {
                    "name": locationName.value,
                    "value": locationName.key
                };
                locationNameOptions.push(locName);
            });

            const defaultLocName = {
                "name": "-- Select A Value --",
                "value": 0
            };

            locationNameOptions.unshift(defaultLocName);
            setLocationNameOptions(locationNameOptions);
        } catch (error) {
            console.error('Error loading location names:', error);
        } finally {
        }

    };

    const LoadTypeOfService = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetTypeOfService`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let typeOfServiceOptions = [];
                resp.map((typeOfService) => {
                    const sertype = {
                        "name": typeOfService.codeDesc,
                        "value": typeOfService.codeID
                    }
                    typeOfServiceOptions = [...typeOfServiceOptions, sertype];

                })
                const defaultLocType = {
                    "name": "-- Select A Value --",
                    "value": 0
                }
                typeOfServiceOptions.unshift(defaultLocType);
                setServiceTypeOptions(typeOfServiceOptions)
            })
    }

    const LoadFundingType = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetFundingType`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let fundingTypeOptions = [];

            data.forEach((fundingType) => {
                const fundtype = {
                    "name": fundingType.codeDesc,
                    "value": fundingType.codeID
                };
                fundingTypeOptions.push(fundtype);
            });

            const defaultFundType = {
                "name": "-- Select A Value --",
                "value": 0
            };

            fundingTypeOptions.unshift(defaultFundType);
            setFundingTypeOptions(fundingTypeOptions);
        } catch (error) {
            console.error('Error loading funding types:', error);
        } finally {

        }
    };

    const LoadContractCompleted = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetContractCompleted`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let contractCompletedOptions = [];

            data.forEach((contractCompleted) => {
                const contcomp = {
                    "name": contractCompleted.codeDesc,
                    "value": contractCompleted.codeID
                };
                contractCompletedOptions.push(contcomp);
            });

            const defaultContractCompleted = {
                "name": "-- Select A Value --",
                "value": 0
            };

            contractCompletedOptions.unshift(defaultContractCompleted);

            setContractCompletedOptions(contractCompletedOptions);
        } catch (error) {
            console.error('Error loading contract completed options:', error);
        } finally {

        }
    };

    const LoadServiceRegion = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}Implementaion/GetServiceRegion`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let serviceRegionOptions = [];

            data.forEach((serviceRegion) => {
                const serreg = {
                    "name": serviceRegion.codeDesc,
                    "value": serviceRegion.codeID
                };
                serviceRegionOptions.push(serreg);
            });

            const defaultServiceRegion = {
                "name": "-- Select A Value --",
                "value": 0
            };

            serviceRegionOptions.unshift(defaultServiceRegion);
            setServiceRegionOptions(serviceRegionOptions);
        } catch (error) {
            console.error('Error loading funding types:', error);
        } finally {

        }
    };

    const OpenEditPop = (row) => {
        setRowData(row);
        LoadLocationName(row.customerKey, row.locationType);
        debugger;
        setHidden(false);
             setModalData(row)

    }

    const LoadImplementSetupData = async (selectedCust) => {

        debugger;
        setLoading(true);
        setStatusBills([]);
        const URL = `${configData.BASE_APP_URL}Implementaion/GetImplementionSetup/${selectedCust}`

        console.log(URL);
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setStatusBills(resp));
        setLoading(false);
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        LoadOwners();
    }, [])


    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;
        // if (ownerkey > 0) {
        //     document.getElementById("owner-error").innerHTML = "";
        //     document.getElementById("owner-highlight").innerHTML = "";
        // }
        var element = document.getElementById("lblOwnerErrorId");

        if (ownerkey != 0) {
            // setHiddenError(true);
            element.innerHTML = ""; // Replace "New text" with the desired content
        }

        LoadCustomers(e);
        setSelectedCust(0);
        setLastCloseDate('');
        setStatusBills([]);
    };

    const onCustomerSelect = (e) => {
        // debugger;
        var customerKey = e;

        var element = document.getElementById("lblCustomerErrorId");

        if (customerKey != 0) {
            setHiddenError(true);
            element.innerHTML = ""; // Replace "New text" with the desired content
        }

        var custkey = e;
        setLastCloseDate('');
        // debugger;
        setSelectedCust(e);
        setStatusBills([]);
        if (custkey > 0) {
            LoadImplementSetupData(e);
            LoadLastCloseDate(e);
            // console.log(detailData);
        }


    };


    const LoadOwners = async () => {
        try {
            const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
            const response = await fetch(custUrl, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            let ownerOptions = data.map(owner => ({
                "name": owner.ownerName,
                "value": owner.ownerID
            }));

            const defaultOwner = {
                "name": "--Select A Value--",
                "value": 0
            };

            ownerOptions.unshift(defaultOwner);
            setOwners(ownerOptions);
            isOwnerLoading(false);

            // Call other functions outside the fetch block to avoid state update issues
            LoadCustomers(0);
            LoadLocationType();
            LoadTypeOfService();
            LoadFundingType();
            LoadContractCompleted();
            LoadServiceRegion();
        } catch (error) {
            console.error('Error loading owners:', error);
            isOwnerLoading(false);
        }
    };


    const LoadCustomers = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isCustomerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCustomerLoading(false);
    }

    const LoadLastCloseDate = async (customerKey) => {

        const URL = `${configData.BASE_APP_URL}Customer/GetCustomerDetails/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                // Assuming the API response contains the lastCloseDate field
                if (resp.lastCloseDate === null || resp.lastCloseDate === "") {
                    // Set resp.lastCloseDate to blank
                    setLastCloseDate('');
                } else {
                    // Convert resp.lastCloseDate to the desired format
                    setLastCloseDate(format(toLocalDate(resp.lastCloseDate), "MM/dd/yyyy"));
                }
                // setLastCloseDate(new Date(resp.lastCloseDate).toLocaleDateString('en-US'));
                setSelectedCustomerName(resp.customerName);
                // console.log(lastCloseDate);
            });
    }




    const handleDeleteRows = async () => {
        // Get the IDs of rows to be deleted
        debugger;
        const selectedRowIds = StatusBills.filter(row => row.checked && !row.isNew).map(row => row.id);

        if (selectedRowIds.length > 0) {

            // Prepare the request URL with customer_key and comma-separated IDs
            const customerKey = selectedCust; // Use the 'cust' state for customer_key
            const idsToDelete = selectedRowIds.join(',');

            const apiUrl = `${configData.BASE_APP_URL}Implementaion/DeleteImplementationSetups?customerkey=${customerKey}&ids=${idsToDelete}`;

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                });

                if (response.ok) {
                    // Delete was successful, update the state and notify parent component
                    window.alert('Data deleted successfully.');
                    const updatedData = StatusBills.filter(row => !row.checked);
                    setStatusBills(updatedData);

                    // window.confirm('Data deleted successfully.');
                } else {
                    // Handle error response from the API if needed
                    console.error('Error deleting rows:', response.statusText);
                    window.alert('Error deleting data.');
                }
            } catch (error) {
                // Handle network or other errors if needed
                console.error('Error deleting rows:', error);
                window.alert('Error deleting data.');
            }
        }
    };

    const handleAddRow = () => {

        setHiddenError(false);
        if (selectedOwner === 0) {
            document.getElementById("lblOwnerErrorId").innerHTML = "Owner is a required field.";
            document.getElementById("lblCustomerErrorId").innerHTML = "Customer is a required field.";
            return
        }

        if (selectedCust === 0) {
            document.getElementById("lblCustomerErrorId").innerHTML = "Customer is a required field.";
            return
        }

        const row = {
            id: '',
            customerKey: selectedCust,
            customerName: selectedCustomerName,
            locationType: 0,
            locationKey: 0,
            serviceType: 0,
            fundingType: 0,
            salesPerson: '',
            contractCompleted: 0,
            contractDate: null,
            projectedVolume: '',
            projectedVolumeSpend: '',
            serviceRegion: 0,
            implementationStartDate: null,
            projectedProductionDate: null,
            actualProductionDate: null,
            createdBy: sessionStorage.getItem('my-username')
            // createdOn: selectedCreatedOn,
            // modifiedBy: sessionStorage.getItem('my-username'),
            // modifiedOn: selectedModifiedOn,
            // dirtyFlag: 'i'
        };
        setLocationNameOptions([{ value: "0", name: "-- Select A Value --" }]);
        OpenEditPop(row);
        setHidden(false);
    };

    const handleCheckboxChange = (checked, row) => {
        const updatedData = StatusBills.map(item => {
            if (item.id === row.id) {
                return { ...item, checked };
            }
            return item;
        });
        setStatusBills(updatedData);
    };

    function formatDateTime(dateTime) {
        if (dateTime) {
            return new Date(dateTime).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
                timeZone: 'UTC'
            });
        }
        return '';
    }

    const handleSave = (isHiddenValue) => {
        debugger;
        setHidden(true);
        // Additional logic or state updates if needed
        LoadImplementSetupData(selectedCust);
    };

    const handleCancel = (isHiddenValue) => {
        debugger;
        setHidden(true);
    };

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />

                    <div className='pt-1 px-3 pb-3 py-3'>

                        <Breadcrumbs title="Implementation Setup" />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}

                        <div className='sticky-top-content'>


                            <div className='floating-table-overlay' hidden={hidden}></div>
                            <div hidden={hidden} className="floating-table shadow-sm full-height-modal" style={{ width: '72%' }}>
                                <div className='row g-0 p-2 bg-white'>
                                    {/* <div className='col-12'> */}
                                    <button onClick={() => setHidden(!hidden)} className='close-modal'><i className="fas fa-times"></i></button>
                                    <ImplementationModal locationType={locationTypeOptions}
                                        locationName={locationNameOptions}
                                        serviceType={serviceTypeOptions}
                                        fundingType={fundingTypeOptions}
                                        contractCompleted={contractCompletedOptions}
                                        serviceRegion={serviceRegionOptions}
                                        detailData={modalData}
                                        onSave={(isHiddenValue) => handleSave(isHiddenValue)}
                                        onCancel={(isHiddenValue) => handleCancel(isHiddenValue)}
                                    />
                                    {console.log(rowData)}
                                    {/* </div> */}
                                </div>
                            </div>

                            <div className='top-filter-container mb-1 py-2 px-2 border rounded-1'>

                                <div className='row'>
                                    <div className='col-3'>
                                        <label id="lblOwnerErrorId" className="text-danger" hidden={hiddenError}></label>
                                    </div>

                                    <div className='col-3'>
                                        <label id="lblCustomerErrorId" className="text-danger" hidden={hiddenError}></label>
                                    </div>

                                </div>

                                <div className='row'>

                                    {/* <div className='col-2'></div> */}

                                    <div className='col-3 top-info'>

                                        <div className="mb-2 form-field">
                                            <label>
                                                Owner
                                                <label className="text-danger">*</label>
                                            </label>
                                            <div>
                                                <SelectSearch
                                                    id="ddnOwn"
                                                    name="ddnOwn"
                                                    value={selectedOwner}
                                                    options={owners}
                                                    onChange={onOwnerSelect}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-3 top-info'>
                                        <div className="mb-2 form-field">
                                            <label>
                                                Customer
                                                <label className="text-danger">*</label>
                                            </label>
                                            <div>
                                                <SelectSearch
                                                    id="ddnCustomer"
                                                    name="ddnCustomer"
                                                    // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                                                    value={selectedCust}
                                                    options={customers}
                                                    onChange={onCustomerSelect}
                                                    search
                                                    filterOptions={fuzzySearch}
                                                >
                                                </SelectSearch>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-2 top-info'>
                                        <div className="mb-2 form-field">

                                            <label>Last Close Date</label>

                                            <div className="mt-2">
                                                <span>{lastCloseDate}</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>


                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Implementation Setup Details
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionSettings">
                                <div className="accordion-body">

                                    <div className='custom-table-text'>
                                        <button className='btn btn-filter mb-2' onClick={handleAddRow}> <i className='fa fa-plus'></i> Add</button>
                                        <button className='btn btn-clear ms-2 mb-2' onClick={handleDeleteRows}> <i className='fa fa-trash'></i> Delete</button>
                                        <div className='main-table-text'>



                                            <div className='react-bootstrap-table'>
                                                <table className='table table-striped table-hover'>
                                                    <thead>
                                                        <tr className='table-top'>
                                                            <th className='center-align' width='30px'></th>
                                                            <th className='center-align' width='50px'>Action</th>
                                                            <th className='center-align' width='100px'>Location Type</th>
                                                            <th className='center-align' width='200px'>Location Name</th>
                                                            <th className='center-align' width='120px'>Type of Service</th>
                                                            {/* <th className='center-align' width='100px'>Funding Type</th> */}
                                                            <th className='center-align' width='80px'>Created By</th>
                                                            <th className='center-align' width='150px'>Created On</th>
                                                            <th className='center-align' width='80px'>Modified By</th>
                                                            <th className='center-align' width='150px'>Modified On</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {StatusBills.map((row, index) => (
                                                            <tr
                                                                key={row.id}
                                                            >
                                                                <td className='center-align'>
                                                                    <input
                                                                        type='checkbox'
                                                                        checked={row.checked}
                                                                        onChange={e => handleCheckboxChange(e.target.checked, row)}
                                                                    />
                                                                </td>
                                                                <td className='center-align'>
                                                                    <i className='fas fa-pencil-alt'
                                                                        onClick={e => OpenEditPop(row)}>
                                                                    </i></td>
                                                                <td className='center-align'>{row.locationTypeName}</td>
                                                                <td className='center-align'>{row.locationDesc}</td>
                                                                <td className='center-align'>{row.serviceTypeDesc}</td>
                                                                {/* <td className='center-align'>{row.fundingTypeDesc}</td> */}
                                                                <td className='center-align'>{row.createdBy ? row.createdBy.toUpperCase() : ''}</td>
                                                                <td className='center-align'>{formatDateTime(row.createdOn)}</td>
                                                                <td className='center-align'>{row.modifiedBy ? row.modifiedBy.toUpperCase() : ''}</td>
                                                                <td className='center-align'>{formatDateTime(row.modifiedOn)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </>
    )
}
